export default __webpack_public_path__ + "static/media/hariporter.4a69917f.png";